module.exports = __webpack_public_path__ + "img/中山公园.3a3d27b9.png";